import Vue from 'vue';

import TopMenu from '@components/header-menu/script.js';

let PageComponent = {
  name: 'warranty',
  data() {
    return {
      template: '<p>default temp</p>',
    };
  },
  components: {
    'header-menu-cmp': TopMenu,
  },
  methods: {
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let products = document.querySelector('#warranty');
    if (products) {
      products.remove();
    }

    let url = '/api/templates/info/warranty';
    Vue.http
      .get(url, { params: to.query })
      // .then(response => response.json())
      .then((data) => {
        next((vm) => vm.setData(data));
      });
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/info/warranty/index.js